import { render } from "./ForgotPassword.vue?vue&type=template&id=11cd7c8c"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/views/ForgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11cd7c8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11cd7c8c', __exports__)) {
    api.reload('11cd7c8c', __exports__)
  }
  
  module.hot.accept("./ForgotPassword.vue?vue&type=template&id=11cd7c8c", () => {
    api.rerender('11cd7c8c', render)
  })

}


export default __exports__